import { PortalProducts } from '~/analytics/types/analytics.type'

import FormAnalytics from '../formAnalytics/formAnalytics'

import { FormNames } from '../formAnalytics/formEvents.types'

import { PurchaseLogPayload } from './todAnalytics.types'

class TodAnalytics extends FormAnalytics {
  public constructor() {
    super(PortalProducts.TUTOR_ON_DEMAND, FormNames.BOOK_A_TUTOR)
  }

  public event(action: string, params: Record<string, string | number | undefined>): void {
    this.logEvent({
      event: action,
      ...params,
    })
  }

  public logCheckout(payload: Pick<PurchaseLogPayload, 'currencyCode' | 'products' | 'revenue'>): void {
    const { currencyCode, products, revenue } = payload

    const event = {
      event: 'checkout',
      ecommerce: {
        currency: currencyCode,
        value: revenue,
        items: products,
      },
    }

    this.logEcommerceEvent(event)
  }

  public logPurchase(payload: PurchaseLogPayload): void {
    const { currencyCode, revenue, products, orderId, coupon } = payload

    const event = {
      event: 'purchase',
      product: 'TOD',
      type: 'TOD',
      order_id: orderId,
      ecommerce: {
        currency: currencyCode,
        transaction_id: orderId,
        value: revenue,
        items: products,
        coupon,
      },
    }

    this.logEcommerceEvent(event)
  }

  public logTodFailure(event: string, payload: any): void {
    this.logEvent({ event, ...payload })
  }
}

export default new TodAnalytics()
